import React from 'react';
import { usePage } from '../../contexts/pageContext';
import styled, { css } from 'styled-components/macro';
import { responsive } from '../../resources/constantes.json';
import { useTranslate } from '../../contexts/languageContext';
import BarraProgresoStyled from '../../components/BarraProgresoStyled';
import Mas from '../../components/svg/Mas';
import Menos from '../../components/svg/Menos';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import Logo from '../../containers/Logo';
import InfoCurules from './InfoCurules';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { fmt } from '../../utils';
import ImgCandidatoConsulta from './ImgCadidatoConsulta';
import FiltroCandidatos from './FiltroCandidatos';

const isReducidoFramed = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return window.top !== window && searchParams.get('reducido') === 'true';
};

const formatCandidatoName = (candidato) =>{
  let candidatonombre = '';
  if(candidato.codcan !== '0'){
    candidatonombre += `(${candidato.codcan}) `
  }
  candidatonombre += `${candidato.nomcan} ${candidato.apecan}`
  return candidatonombre;
}

const FilaTablaPartidos = props => {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const partido = props.partido.act;
  const estiloComposicion = props.soloConCargo;
  const isMobile = useIsMobile();
  const partidoInfo = nomenclator.partidos[Number(partido.codpar) - 1];
  const [isOpen, setIsOpen] = React.useState(false);
  const [candidatos, setCandidatos] = React.useState(partido.cantotabla);
  React.useEffect(() => {
    setIsOpen(false);
    setCandidatos(partido.cantotabla);
  }, [partido]);

  const expandirContraer = e => {
    if (typeof e === 'object') e.preventDefault();
    setIsOpen(!isOpen);
  };

  const showCurulCandidato = candidato => {
    if (props.mostrarCargos) {
      if (candidato.pref === '1' && candidato.carg === '1') {
        return true;
      } else if (
        candidato.codcan !== '0' &&
        candidato.carg === '1'
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const showVotosCandidato = candidato => {
    if (candidato.pref === '1') {
      return true;
    } else if (candidato.pref === '0' && candidato.codcan === '0') {
      return true;
    } else {
      return false;
    }
  };

  const ElementoListaCandidatos = ({ candidato: candidato }) => {
    return (
      <ElementoCandidatos>
        <NombreCandidato>
         {formatCandidatoName(candidato)}
        </NombreCandidato>
          <>
            {showVotosCandidato(candidato) && (<>
              <p className="percent">{candidato.pvot}</p>{' '}
              <p>{fmt(candidato.vot)}</p>
            </>)}
            <ContenedorVotoProferente>
              {
                candidato.empate === '1' && candidato.carg !== '0'
                ? (<SinAsignar title={t('curulSA')}>{t('SA')}</SinAsignar>)
                : (
                  showCurulCandidato(candidato) && <VotoPreferente />
                )
              }
            </ContenedorVotoProferente>
          </>
      </ElementoCandidatos>
    );
  };
  return (
    <BigContainer>
      {partidoInfo && (
        <Container estiloComposicion={estiloComposicion} className={`className`} showCargos={false}>
          <BloquePartido className="bloque flex">
            {!isMobile && (
              <div>
                {props.configConsultas && (
                  <ImgCandidatoConsulta
                    codpar={
                      nomenclator.partidos[Number(partido.codpar) - 1].codpar
                    }
                    codcan={partido.cantotabla[0].codcan}
                  />
                )}

                <StyledLogo
                  codpar={
                    nomenclator.partidos[Number(partido.codpar) - 1].codpar
                  }
                />
              </div>
            )}
            <Contenido>
              <Up className={'titleUp'}>
                <div className={estiloComposicion? 'configComposicion': ""}>
                  {props.configConsultas && partido.cantotabla && (
                    <NombreCandidatoConsulta>
                      {partido.cantotabla[0].nomcan}{' '}
                      {partido.cantotabla[0].apecan}
                    </NombreCandidatoConsulta>
                  )}
                  <NombrePartido configConsultas={props.configConsultas}>
                    {partidoInfo.nombre}
                  </NombrePartido>
                </div>

                {props.mostrarVotos && (
                  <Datos className="agr flex">
                    <div className="porcAgr">{partido.pvot}</div>
                    <div className="numAgr">{fmt(partido.vot)}</div>
                  </Datos>
                )}
                {props.mostrarCargos && (
                  <InfoCurules
                    cargos={Number(partido.cargElectos)}
                    cargEmpatados={partido.cargEmpatados}
                    color={partidoInfo.color}
                  />
                )}
              </Up>
              <Down className="down">
                {props.mostrarVotos && (
                  <BarraProgresoStyled
                    porcentaje={partido.pvot}
                    color={partidoInfo.color ? partidoInfo.color : '#c4c4c4'}
                    cual={partido.cod}
                  />
                )}
              </Down>
            </Contenido>

            {props.mostrarCandidatos && (
              <ContainerMasMenos className="containerMasMenos flex">
                {isOpen ? (
                  <button
                    tabIndex={-1}
                    onClick={() => {
                      expandirContraer();
                    }}
                  >
                    <Menos />
                  </button>
                ) : (
                  <button
                    tabIndex={-1}
                    onClick={() => {
                      expandirContraer();
                    }}
                  >
                    <Mas />
                  </button>
                )}
              </ContainerMasMenos>
            )}
          </BloquePartido>
          {isOpen && partido.cantotabla ? (
            <>
              <Divider />
              <FiltroCandidatos candidatos={partido.cantotabla} setCandidatos={setCandidatos}/>
              <ContainerLista>
                { candidatos.length > 0 ? candidatos.map((candidato, i) => {
                  return (
                    <ElementoListaCandidatos candidato={candidato} key={i} />
                  );
                })
                : <ElementoCandidatos>{t('sinResultados')}</ElementoCandidatos>
              }
              </ContainerLista>
            </>
          ) : (
            <div />
          )}
        </Container>
      )}
    </BigContainer>
  );
};

const ContenedorVotoProferente = styled.div`
  padding-left: 10px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  width:20px;
`;

const VotoPreferente = styled.span`
  background: #54b8ec;
  height: 5px;
  width: 5px;
  display: block;
  border-radius: 50%;
`;

const SinAsignar = styled.span`
  display: flex;
  justify-content: flex-start;
`;

const ContainerLista = styled.div`
  max-height: 140px;
  overflow: auto;
`;

const NombreCandidato = styled.p`
  width: 300px;
`;
const ElementoCandidatos = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1f3f5;
  padding-top: 8px;
  .percent {
    font-size: 1.5rem;
    font-weight: 600;
    margin-right: 1rem;
    width:100px;
  }
`;

const BigContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 98%;
  border: 1px solid #d8d8d8;
  border-radius: 3px;
  margin-bottom: 30px;
`;

const NombrePartido = styled(({ configConsultas, ...rest }) => <p {...rest} />)`
  font-family: Lato;
  font-size: ${({ configConsultas }) => (configConsultas ? '12px' : '14px')};
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  width: ${({ configConsultas }) => (configConsultas ? 'auto' : '310px')};
  @media screen and (max-width: 1150px) {
    width: ${({ configConsultas }) => (configConsultas ? 'auto' : '250px')};
  }

  @media screen and (max-width: ${responsive.mobile}px) {
    width: ${({ configConsultas }) => (configConsultas ? 'auto' : '200px')};
    margin-bottom: 5px;
  }
`;

const NombreCandidatoConsulta = styled.p`
  font-family: Lato;
  font-size: 19px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;

const BloquePartido = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Container = styled(({ estiloComposicion, ...rest }) => <div {...rest} />)`
  display: flex;
  justify-content: space-around;
  background-color: white;
  flex-direction: column;
  margin: 1rem;
  width: calc(100% - 1rem);

  margin-top:${({ estiloComposicion }) => (estiloComposicion  ? '0px' : '1rem')};
  margin-bottom: ${({ estiloComposicion  }) => (estiloComposicion  ? '0px' : '1rem')};

  .porcAgr {
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: right;
  }

  @media screen and (max-width: ${responsive.tablet}px) {
    width: ${({ showCargos }) =>
      showCargos ? '70% !important' : isReducidoFramed() ? '100%' : '96%'};
  }

  @media screen and (max-width: ${responsive.mobile}px) {
    padding: 0;
  }
`;

const StyledLogo = styled(Logo)`
  flex: 0 0 auto;
  width: 60px;
  background: grey;
`;

const ContainerMasMenos = styled.div`
  display: flex;
  visibility: ${isReducidoFramed() ? 'hidden' : 'visible'};
  width: ${({ isMobile }) => (isMobile ? '10%' : '5%')};
  justify-content: center;
  margin-left: ${({ isMobile }) => (isMobile ? '2%' : '1rem')};

  button {
    background: transparent;
  }

  svg {
    width: ${({ isMobile }) => (isMobile ? '18px' : '24px')};
    height: ${({ isMobile }) => (isMobile ? '18px' : '24px')};
  }

  @media screen and (max-width: ${responsive.mobile}px) {
    width: 10%;
    margin-left: 2%;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

const Contenido = styled.div`
  width: 78%;
  display: flex;
  flex-direction: column;

  &.Listas:not(:first-child) {
    margin-top: 2.5rem;
  }

  &.contenidoListas .up {
    align-items: center;
  }

  .titleUp {
    height: 100%;
  }
  @media screen and (max-width: ${responsive.mobile}px) {
    width: 85%;
  }
`;

const Datos = styled.div`
  display: flex;
  &.agr {
    flex-direction: column;
    justify-content: center;
    width: 100px;
    font-weight: 100;
  }

  &.listas {
    flex-direction: row;
    align-items: baseline;
  }
  .porcAgr,
  .numAgr {
    text-align: right;
  }

  .porcListas {
    font-weight: 600;
    font-size: 1.6rem;
    margin-right: 1rem;

    @media print {
      font-size: 1rem;
    }
  }

  .numListas {
    font-size: 1.4rem;
    font-weight: 400;

    @media print {
      font-size: 1rem;
    }
  }
`;

const Up = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  .configComposicion {
    display: flex;
    align-items: center;
  }
`;

const Down = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Divider = styled.div`
  border-bottom: 2px dashed #c2d2f1;
  margin-top: ${isReducidoFramed() ? '0' : '3rem'};
  margin-bottom: ${isReducidoFramed() ? '0' : '1rem'};

  @media print {
    display: none;
  }
`;



export default FilaTablaPartidos;
